import React, { useState, useEffect } from "react"
import { Container, Grid } from "@material-ui/core"
import LabelPure from "../../pures/label/label.pure"
import { ArrowBtnHLPure, ButtonHLPure, CheckBoxHLPure, DialogSystemGLPure, DropDownBtnHLPure, InputHLPure, SimpleLoading, TextAreaHLPure, ButtonAddHLPure, DialogFormHLPure } from "../../pures"
import { NIL as NIL_UUID } from 'uuid'
import { useTranslation } from "react-i18next"
import { QuestionnaireService, ContractService } from "../../../services"
import "./questionnaires-administration.new.questionnaire.view.css"
import StandardTemplatesView from "./standard-templates.view"
import { useLocation } from 'react-router-dom'
import { RadioButton } from "@progress/kendo-react-inputs"
import { useMediaQuery } from "@material-ui/core"

const QuestionnairesAdministrationNewQuestionnaireView = ({
    companySelected,
    user,
    token,
    toggleCompleteRequest,
    showDetailComponent,
    toggleShowDetailComponent,
    hideShowDetails,
    showCompletedRequest,
    setShowComponentDetail,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    showLoadingRequesting,
    setTemplates,
    templates,
    standardContract,
    changeRedirect,
    changeRoute,
    icons
}) => {
    const { t } = useTranslation();

    const assignTemplateText = t("digitalContractHomeView.questionnaires.assignTemplate")

    let location = useLocation();
    let urlContract = location.pathname

    const [showGettingData, setShowGettingData] = useState(false);
    const [nameVoidWarning, setNameVoidWarning] = useState(false);
    const [comments, setComments] = useState("");
    const [nameQuestionnaire, setNameQuestionnaire] = useState("");
    const [showWarningRequesting, setShowWarningRequesting] = useState(false);
    const [template, setTemplate] = useState(assignTemplateText);
    const [nameCompany, setNameCompany] = useState(t("questionnairesAssignCategories.no.assign"));
    const [copyComplteTemplates, setCopyCompleteTemplates] = useState([])
    const [templatesToShow, setTemplatesToShow] = useState([])
    const [messageError, setMessageError] = useState(t("questionnairesAdministrationNewQuestionnaireView.input.name.error.label"))
    const [showStandardTemplates, setShowStandardTemplates] = useState(false)
    const [standardContractSelected, setStandardContractSelected] = useState(false)
    const [showDialogIcon, setShowDialogIcon] = useState(false)
    const [imageTitle, setImagetitle] = useState(null);

    let templatesToDrop = [{
        active: true,
        clientId: 0,
        companyId: NIL_UUID,
        createdDate: "",
        deactivationReason: null,
        description: "",
        documentLoaded: null,
        documentPath: null,
        id: NIL_UUID,
        name: assignTemplateText,
        templateVariable: [],
        updatedDate: "",
        variableCount: null
    }
    ]


    const handleChangeComments = (e) => {
        setComments(e.target.value);
    };

    const handleChangeInputNameQuestionnaire = (e) => {
        setNameQuestionnaire(e.target.value);
    }

    const handleChangeDropTemplate = (e) => {
        const selectedTemplate = templates.find(item => item.id == e.target.value)
        setTemplate(selectedTemplate ?? assignTemplateText)
    }

    //get all templates by company was selected
    useEffect(() => {
        if (companySelected.length > 0) {
            if (companySelected[0].id !== NIL_UUID) {
                setNameCompany(companySelected[0].companyName)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
        let allData = []
        let copyTemplates = [...templates]
        let companyId = companySelected[0]?.id ? companySelected[0]?.id : NIL_UUID
        let filteredTemplates = [...templates]
        if (companyId) {
            filteredTemplates = copyTemplates.filter((item) => item.companyId === companyId)
        }
        filteredTemplates.unshift(templatesToDrop[0])
        for (let i = 0; i < filteredTemplates.length; i++) {
            if (filteredTemplates[i].name !== '' && filteredTemplates[i].id !== '') {
                allData.unshift(filteredTemplates[i])
            }
            // allData.name = copyTemplates[i].name
            // allData.push(allData.name)
        }

        let dataConvert = Object.values(filteredTemplates)
        // if (companyId) {
        //     setidTemplate(filteredTemplates[0].id)
        // }
        setCopyCompleteTemplates(filteredTemplates)
        setTemplatesToShow(filteredTemplates)
        // if (filteredTemplates.length <= 1) {
        //     setMessageError("Esta empresa no tiene templates asociados.")
        //     setNameVoidWarning(true)
        //     setTimeout(() => {
        //         hideShowDetails()
        //         setNameVoidWarning(false)
        //     }, 3000)
        // }
    }, [templates])

    const handleCreateQuestionnaire = async () => {
        if (nameQuestionnaire === '') {
            setNameVoidWarning(true)
            setMessageError(t("questionnairesAdministrationNewQuestionnaireView.input.name.warning.label"))
            setTimeout(() => {
                setNameVoidWarning(false)
            }, 2000);
        } else {
            if ((template.id && (!template.companyId || !template.clientId) && !standardContractSelected)) {
                setNameVoidWarning(true)
                setMessageError(t("No se ha elegido un template"))
                setTimeout(() => {
                    setNameVoidWarning(false)
                }, 2000)
                return
            }
            await toggleLoadingRequesting(true)
            const logo = imageTitle && imageTitle !== "" && imageTitle !== undefined && imageTitle !== null ? imageTitle : ''
            let companyId = companySelected && companySelected !== '' && companySelected !== undefined && companySelected.length > 0 ? companySelected[0].id : NIL_UUID
            let clientId = user.userMetaData.userA3Cloud.clientId
            let templateIdSelect = NIL_UUID
            let userId = user.userMetaData.userA3Cloud.clientId;
            if (template === assignTemplateText || (template.id === templateIdSelect)) {
                await toggleLoadingRequesting(false)
                setNameVoidWarning(true)
                setMessageError("Selecciona un template")
                setTimeout(() => {
                    setNameVoidWarning(false)
                }, 2000);
                setShowGettingData(false)
                return
            }
            const templateId = template.id
            //create a questionnaire
            let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
            let contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API);

            try {
                let questionnaireCreated = await questionnaireService.createQuestionnaire(token, companyId, clientId, templateId, nameQuestionnaire, comments, logo)
                if (questionnaireCreated && questionnaireCreated.statusCode === 200) {
                    let questionnaires = await contractService.getQuestionnairesByUserId(token, userId)
                    await toggleLoadingRequesting(false)
                    if (urlContract === "/digital-contract/standar-contracts" && changeRoute) {
                        changeRoute(0)
                    } else {
                        await toggleCompletedRequesting(true, '', questionnaires.data.data)
                        setTimeout(() => {
                            hideShowDetails()
                        }, 4000)
                    }
                } else if (questionnaireCreated.statusCode === 10) {
                    await toggleLoadingRequesting(false)
                    setMessageError(t("questionnairesAdministrationNewQuestionnaireView.error.modal.questionnaire.exist"))
                    toggleErrorRequesting(true)
                    setTimeout(() => {
                        toggleErrorRequesting(false)
                    }, 2000);
                } else {
                    await toggleLoadingRequesting(false)
                    await toggleErrorRequesting(true)
                    setTimeout(() => {
                        toggleErrorRequesting(false)
                    }, 2000);
                }
            } catch (error) {
                await toggleLoadingRequesting(false)
                await toggleErrorRequesting(true)
                setTimeout(() => {
                    toggleErrorRequesting(false)
                }, 2000);
            }
        }
    };

    const toggleWarningRequesting = () => {
        setShowWarningRequesting(false)
    }

    useEffect(() => {
        if (standardContract) {
            setShowStandardTemplates(true)
            setStandardContractSelected(true)
        }
        changeRedirect(false)
    }, [])

    const toggleDialogIcon = () => {
        setShowDialogIcon(!showDialogIcon);
    };

    const onCancelIcon = () => {
        toggleDialogIcon();
        setImagetitle(null);
    };

    //save icon
    const onSaveImg = (e) => {
        e.preventDefault();
        toggleDialogIcon();
    };

    const isMobile = useMediaQuery("(max-width:560px")

    return showGettingData ? (
        <div className="questionnairesAdministrationNewQuestionnaireView-loader">
            <SimpleLoading />
        </div>
    ) : (
        <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="questionnairesAdministrationNewQuestionnaireView-wrapper"
        >
            {showLoadingRequesting ? <DialogSystemGLPure toggleLoadingRequesting={toggleLoadingRequesting} showLoadingRequesting={showLoadingRequesting} /> : null}
            {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}
            {nameVoidWarning ? <DialogSystemGLPure toggleWarningRequesting={toggleWarningRequesting} showWarningRequesting={nameVoidWarning} message={messageError} /> : null}
            {showErrorRequesting ? <DialogSystemGLPure toggleErrorRequesting={toggleErrorRequesting} showErrorRequesting={showErrorRequesting} /> : null}

            {
                showStandardTemplates ?
                    <StandardTemplatesView
                        toggleErrorRequesting={toggleErrorRequesting}
                        onBack={() => setShowStandardTemplates(false)}
                        onSelect={(template) => {
                            setTemplate(template)
                        }}
                        changeRoute={changeRoute}
                    />
                    : <Container maxWidth={"lg"} disableGutters>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                {
                                    nameCompany !== t("questionnairesAssignCategories.no.assign")
                                        ? <div className="questionnairesAdministrationNewQuestionnaireView-subtitle">
                                            <LabelPure title={`${t("questionnairesAdministrationNewQuestionnaireView.label.name.questionnaire.for.company")} ${nameCompany}`} />
                                        </div>
                                        : <div className="questionnairesAdministrationNewQuestionnaireView-subtitle">
                                            <LabelPure title={`${t("questionnairesAdministrationNewQuestionnaireView.label.name.questionnaire.for.company.sin.asignar")} ${nameCompany}`} />
                                        </div>
                                }
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <InputHLPure
                                            valueInput={nameQuestionnaire}
                                            labelInput={t("questionnairesAdministrationNewQuestionnaireView.label.name.questionnaire")}
                                            typeInput={"text"}
                                            characterLimit={30}
                                            handleChangeInput={(e) => handleChangeInputNameQuestionnaire(e)}
                                            tooltipShow={true}
                                            positionTooltip={isMobile ? "top" : "right"}
                                            titleTooltip={t("questionnairesAdministrationNewQuestionnaireView.tooltip.title.name.questionnaire")}
                                            descriptionTooltip={t("questionnairesAdministrationNewQuestionnaireView.tooltip.description.name.questionnaire")}
                                            informationIcon={true}
                                            inputActive={true}
                                        />
                                    </Grid>

                                    {
                                        templatesToShow.length &&

                                        <Grid item xs={12}>
                                            <CheckBoxHLPure
                                                onChangeHandler={() => setStandardContractSelected(!standardContractSelected)}
                                                disabled={!standardContractSelected}
                                                checkedState={!standardContractSelected}
                                                labelCheckBox={t("digitalContractDashboard.questionnaires.relatedQuestionnaire")}
                                                tooltipShow={true}
                                                positionTooltip={isMobile ? "top" : "right"}                                                
                                                titleTooltip={t("questionnairesAdministrationNewQuestionnaireView.drop.template.tooltip.name")}
                                                descriptionTooltip={t("questionnairesAdministrationNewQuestionnaireView.drop.template.tooltip.description")}
                                                informationIcon={true}
                                            />
                                            <DropDownBtnHLPure
                                                disable={standardContractSelected}
                                                // labelDropDown={t("questionnairesAdministrationNewQuestionnaireView.label.title.name.template")}
                                                optionsDropDown={templatesToShow}
                                                valueItem="id"
                                                nameOption="name"
                                                onDropDownChange={(e) => handleChangeDropTemplate(e)}
                                            />
                                        </Grid>
                                    }

                                    {
                                        (template == assignTemplateText || (template.id && template.companyId == null && template.clientId == null)) &&
                                        <Grid item xs={12} className="questionnairesAdministrationNewQuestionnaireView-standardTemplate">
                                            <CheckBoxHLPure
                                                onChangeHandler={() => setStandardContractSelected(!standardContractSelected)}
                                                checkedState={standardContractSelected}
                                                disabled={standardContractSelected}
                                                labelCheckBox={t("digitalContractDashboard.questionnaires.useStandardContract")}
                                                tooltipShow={true}
                                                positionTooltip={isMobile ? "top" : "right"}
                                                titleTooltip={t("digitalContractDashboard.questionnaires.tooltipTitle")}
                                                descriptionTooltip={t("questionnairesAdministrationNewQuestionnaireView.checkbox.template.tooltip.description")}
                                                informationIcon={true}
                                            />
                                            <ArrowBtnHLPure
                                                disabled={!standardContractSelected}
                                                textArrowBtn={t("digitalContractDashboard.questionnaires.dropdownPlaceholder")}
                                                onClickArrowBtn={() => setShowStandardTemplates(true)}
                                            />
                                            {(template.id && template.companyId == null && template.clientId == null && standardContractSelected) &&
                                                <InputHLPure
                                                    labelInput={t("digitalContractDashboard.questionnaires.assignCategoryTitle")}
                                                    valueInput={template.name}
                                                    inputActive
                                                    disabled
                                                    readOnlyText
                                                    styleGrid={{ marginTop: 10 }}
                                                />
                                            }
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextAreaHLPure
                                    labelTextArea={t("questionnairesAdministrationNewQuestionnaireView.title.description.texarea")}
                                    handleChangeTextArea={(e) => handleChangeComments(e)}
                                    valueTextData={comments}
                                    characterLimit={55}
                                />
                                <ButtonAddHLPure
                                    iconAdd={true}
                                    nameBtn={t("digitalContractDashboard.questionnaires.iconTitle")}
                                    onClickBtn={() => toggleDialogIcon()}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="questionnairesAdministrationNewQuestionnaireView-container-btn"
                            >
                                <ButtonHLPure
                                    nameBtn={t("button.cancel")}
                                    onClickBtn={() => {
                                        changeRoute("questionnaires")
                                        hideShowDetails()
                                    }}
                                />
                                <ButtonHLPure
                                    nameBtn={t("button.save")}
                                    primary
                                    onClickBtn={handleCreateQuestionnaire}
                                />
                            </Grid>
                        </Grid>
                    </Container>
            }
            {showDialogIcon && (
                <DialogFormHLPure
                    cancel={onCancelIcon}
                    titleDialog={t(
                        "dialogSignRequestPure.titleDialogSignRequest"
                    )}
                    descriptionActive={true}
                    descriptionDialog={t(
                        "questionnairesAdministrationView.dialog.choose.icon.description"
                    )}
                    textBtnCancel={t("button.cancel")}
                    saveBtn={t("button.save")}
                    handleSubmit={(event) => onSaveImg(event)}
                // loadingComponent={isLoading}
                >
                    <div
                        className="signatureProfilesDetailsView-container-gallery"
                        sm={12}
                        xs={12}
                        lg={12}
                        md={12}
                    >
                        {icons.map((item, index) => (
                            <div className="signatureProfilesDetailsView-container-icons">
                                <RadioButton
                                    className="signatureProfilesDetailsView-radioBtn-img"
                                    name="icon"
                                    value={item.path}
                                    checked={imageTitle === item.path}
                                    onChange={({ value }) => setImagetitle(value)}
                                />
                                <img
                                    src={item.path}
                                    {...item}
                                    className="icon-style"
                                    key={index}
                                />
                            </div>
                        ))}
                    </div>
                </DialogFormHLPure>
            )}
        </Grid>
    );
}
export default QuestionnairesAdministrationNewQuestionnaireView;